import { render, staticRenderFns } from "./PurchaseFail.vue?vue&type=template&id=b4b516a6&lang=pug&"
import script from "./PurchaseFail.vue?vue&type=script&lang=js&"
export * from "./PurchaseFail.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseFail.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports